import api from 'config/api';
import { Notification } from 'notification/notification';
import { logout } from './auth';

export const handleSendGeneric = async (pathUrl, typeForm, values) => {
  switch (typeForm) {
    case 'POST':
      return handleSendPost(pathUrl, values);
    case 'GET':
      return handleSendGet(pathUrl);
    case 'PUT':
      return handleSendPut(pathUrl, values);
    case 'DELETE':
      return handleSendDelete(pathUrl, values);
    default:
      break;
  }
};

const handleSendPost = async (pathUrl, values) => {
  try {
    const response = await api.post(pathUrl, values);
    if (response.status === 401 || response.status === 403) {
      handleLoginAgain(response);
      Notification(401);
    }
    return response;
  } catch (error) {
    handleErrorNotification(error);
  }
};

const handleSendPut = async (pathUrl, values) => {
  try {
    const response = await api.put(pathUrl, values);
    if (response.status === 401 || response.status === 403) {
      handleLoginAgain(response);
      Notification(401);
    }
    return response;
  } catch (error) {
    handleErrorNotification(error);
  }
};

const handleSendDelete = async (pathUrl, values) => {
  try {
    const response = await api.delete(
      values === undefined ? pathUrl : pathUrl + values
    );
    if (response.status === 401 || response.status === 403) {
      handleLoginAgain(response);
      Notification(401);
    }
    return response.status;
  } catch (error) {
    handleErrorNotification(error);
  }
};

const handleSendGet = async (pathUrl) => {
  try {
    const { status, data } = await api.get(pathUrl);
    if (status === 401 || status === 403) {
      handleLoginAgain(data);
      Notification(401);
    }
    return data;
  } catch (error) {
    handleErrorNotification(error);
  }
};

const handleErrorNotification = (error) => {
  if (error.response) {
    const { data, status } = error.response;
    Notification(status, data.message);
  }
};

function handleLoginAgain(response) {
  const validation = 'Full authentication is required to access this resource';
  if (response === validation || response?.data === validation) {
    logout();
    window.location.reload();
  }
}
